import { render } from "./PlanningFormComponent.vue?vue&type=template&id=5dcb12ca"
import script from "./PlanningFormComponent.vue?vue&type=script&lang=js"
export * from "./PlanningFormComponent.vue?vue&type=script&lang=js"

import exportComponent from "/Users/vincent/Herd/app.prixo.io/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__